<script setup>
import { ref, computed } from 'vue'
import { QIcon, QTooltip } from 'quasar'
import { DxNumberBox } from 'devextreme-vue/number-box'
import { getI18n } from '@/plugins/i18n'

import { useGarageStore } from '@/stores/garage.store'

const garageStore = useGarageStore()

const emit = defineEmits({
  valueChanged: (value) => true,
})

const props = defineProps({
  data: {
    type: Object,
    default: null
  },
  value: {
    type: Number,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  currentCarService: {
    type: Number,
    default: null,
  },
  garageReasonRef: {
    type: Number,
    default: null,
  },
  min: {
    type: Number,
    default: 1,
  },
  max: {
    type: Number,
    default: 9999,
  },
  step: {
    type: Number,
    default: 1,
  },
})

const internalValue = ref(props.value)
const i18n = getI18n()

const onValueChanged = (e) => {
  internalValue.value = e.value
  emit('valueChanged', e.value)

  if (props.data?.setValue) {
    // DataGrid
    props.data.setValue(e.value)
  } else if (props.data?.component && props.data?.dataField) {
    // dxForm
    props.data.component.updateData(props.data.dataField, e.value)
  } else if (props.data) {
    props.data.car_service = e.value
  }
}

const showWarningIcon = computed(() => {
  if (props.disabled) return false
  if (internalValue.value == null) return false
  if (props.currentCarService == null) return false

  return internalValue.value < props.currentCarService - 1
})

const warningMessage = computed(() => {
  if (!showWarningIcon.value) return ''
  return i18n.t('common.lastCarServiceNumber', { car_service: props.currentCarService - 1 })
})

const internalDisabled = computed(() => {
  const garageReason = garageStore.garageReasons.find(i => i.id === props.garageReasonRef)
  const interventionType = garageStore.interventionTypes.find(i => i.id === garageReason?.intervention_type_ref)
  return !interventionType?.has_car_service
})
</script>

<template>
  <div
    class="car-service-number-box"
    style="display: flex; align-items: center;"
  >
    <dx-number-box
      v-model="internalValue"
      :disabled="props.disabled || internalDisabled"
      :min="props.min"
      :max="props.max"
      :step="props.step"
      style="flex-grow: 1;"
      @value-changed="onValueChanged"
    />

    <q-icon
      v-if="showWarningIcon"
      name="mdi-alert"
      color="orange"
      style="margin-left: .25rem;"
      size="xs"
      @contextmenu.prevent
    >
      <q-tooltip v-if="showWarningIcon">
        {{ warningMessage }}
      </q-tooltip>
    </q-icon>
  </div>
</template>
